module.exports = __webpack_public_path__ + "static/media/foundation.6202e402.jpg";